import type { Project, StudioState } from './studioModel';

/** Published Gambit roots share the saved chapter chain with Classic. */
export const projectSavedStoryId = (project: Project) => project.continuation?.storyId
  || project.continuationSource?.storyId
  || project.chapters.flatMap(chapter => chapter.sequences).find(sequence => sequence.publishedStory?.storyId)?.publishedStory?.storyId;

export type UnfinishedGambitChapter = { projectId: string; chapterId: string; title: string };

/** Match saved identities, never titles. A published chapter's older takes are
 * not another unfinished sequel, and an empty chat is not saved progress. */
export function unfinishedGambitChapter(workspace: StudioState | undefined, storyId: string, chapterIds: string[] = []): UnfinishedGambitChapter | undefined {
  if (!workspace || !storyId) return;
  const savedIds = new Set([storyId, ...chapterIds]);
  for (const project of [...workspace.projects].sort((a, b) => (b.updatedAt || '').localeCompare(a.updatedAt || ''))) {
    const linked = savedIds.has(project.continuation?.storyId || project.continuationSource?.storyId || '');
    const publishedIndex = project.chapters.reduce((last, chapter, index) => chapter.sequences.some(take =>
      savedIds.has(take.publishedStory?.storyId || '')) ? index : last, -1);
    if (!linked && publishedIndex < 0) continue;
    for (const chapter of project.chapters.slice(publishedIndex + 1)) {
      if (chapter.sequences.some(take => take.publishedStory || take.localStory)) continue;
      const progress = chapter.sequences.some(take => Object.values(take.artifacts).some(Boolean))
        || chapter.jobs?.some(job => ['queued', 'running'].includes(job.status))
        || Object.values(chapter.prompts || {}).some(value => value?.trim())
        || chapter.conversations.some(chat => chat.messages.length > 0);
      if (progress) return { projectId: project.id, chapterId: chapter.id, title: chapter.title };
    }
  }
}

export const gambitChapterUrl = (chapter: UnfinishedGambitChapter) =>
  `/create/gambit?${new URLSearchParams({ projectId: chapter.projectId, chapterId: chapter.chapterId })}`;
